import script from "./mg-lightbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./mg-lightbox.vue?vue&type=script&setup=true&lang=ts"

import "./mg-lightbox.vue?vue&type=style&index=0&id=3856e448&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3856e448"]])

export default __exports__